import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesProducts } from "../../constants";

export const requestDeleteProductComment = async (
  reviewId: string
): Promise<void> => {
  return await instance.delete(
    buildUrl(ApiRoutesProducts.ProductComments, reviewId)
  );
};
